import { gql } from "graphql-tag";

export const updateReadingJournal = gql`
  mutation UpdateReadingJournalEntry(
    $id: Int!
    $object: ReadingJournalUpdateType!
  ) {
    updateResponse: update_reading_journal(id: $id, object: $object) {
      reading_journal {
        ...ReadingJournalFragment
      }
    }
  }
`;
